import { PopperProps } from '@mui/material/Popper'
import cn from 'classnames'
import Tooltip from 'ext-ui/components/Tooltip/Tooltip'
import { styles } from 'ext-ui/components/TooltipIcon/TooltipIcon.style'
import React, { ReactElement, useState } from 'react'
import SvgTooltip from 'src/components/Svgs/SvgTooltip'
import SvgTooltipHoverColored from 'src/components/Tooltip/SvgTooltipHoverColored'

export type TooltipIconProps = {
  icon?: React.ReactNode
  iconTestId?: string
  iconHover?: React.ReactNode
  arrow?: boolean
  variant?: 'default' | 'spotlight' | 'light'
  size?: 'medium'
  placement?: PopperProps['placement']
  children: React.ReactNode
  className?: string
  disableInteractive?: boolean
  enterDelay?: number
  exitDelay?: number
}

function TooltipIcon(props: TooltipIconProps): ReactElement {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const {
    icon = <SvgTooltip />,
    iconTestId,
    iconHover = props.icon ?? <SvgTooltipHoverColored />,
    variant = 'default',
    size = 'medium',
    placement = 'top',
    arrow = true,
    className,
    children,
    disableInteractive = true,
    enterDelay,
    exitDelay,
  } = props

  // Needed for race hover error: Skip state management if icon doesn't change on hover
  const skipStateManagement = props.iconHover === undefined

  return (
    <div css={styles} className={cn(className, size)}>
      <Tooltip
        tooltipContent={children}
        arrow={arrow}
        variant={variant}
        placement={placement}
        disableInteractive={disableInteractive}
        enterDelay={enterDelay}
        exitDelay={exitDelay}
        onOpen={
          skipStateManagement
            ? undefined
            : (): void => {
                setTooltipOpen(true)
              }
        }
        onClose={
          skipStateManagement
            ? undefined
            : (): void => {
                setTooltipOpen(false)
              }
        }
      >
        <div className={'icon-wrapper'} data-testid={iconTestId}>
          {skipStateManagement ? icon : !tooltipOpen ? icon : iconHover}
        </div>
      </Tooltip>
    </div>
  )
}

export default TooltipIcon
